import React, {useEffect} from "react";
import profileImage from "../../../../assets/user-profile.png";
import { useNavigate } from "react-router-dom";
import "./chatheader.css";
import {useStateValue} from "../../../../stateprovider";

const Chatheader = () => {
    const [{appIconState}] = useStateValue();
    const navigate = useNavigate();




    return <div className="chatheader">
        <div className='app_uh_top'>
        <div className='app_uh_top_profile'>
        {
            appIconState === 3 ? <p className="app_feedback_head_para">Feedback</p> :<>
            <img src={profileImage} alt="user-profile" />
            <p>Ponmile Tambore</p>
            </>
        }
       
        </div>
           
            <div className='app_uh_noti'>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none" onClick={()=> navigate("/user-home")}>
                    <path d="M23 23C24.1046 23 25 22.1046 25 21V8.81395C25 8.1034 24.623 7.44619 24.0096 7.0875L14.561 1.56198C13.9635 1.21257 13.2278 1.19693 12.616 1.52063L2.06466 7.10335C1.40969 7.4499 1 8.13016 1 8.87116V21C1 22.1046 1.89543 23 3 23H10V15.9444C10 15.116 10.6716 14.4444 11.5 14.4444H14.5C15.3284 14.4444 16 15.116 16 15.9444V18.7222V23H23Z" fill="#01B6E2" />
                    <path d="M16 23H23C24.1046 23 25 22.1046 25 21V8.81395C25 8.1034 24.623 7.44619 24.0096 7.0875L14.561 1.56198C13.9635 1.21257 13.2278 1.19693 12.616 1.52063L2.06466 7.10335C1.40969 7.4499 1 8.13016 1 8.87116V21C1 22.1046 1.89543 23 3 23H10M16 23H10M16 23V18.7222V15.9444C16 15.116 15.3284 14.4444 14.5 14.4444H11.5C10.6716 14.4444 10 15.116 10 15.9444V23" stroke="#01B6E2" stroke-linejoin="round" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                    <path d="M14.3333 26.083C15.6167 26.083 16.6667 25.033 16.6667 23.7497H12C12 24.3685 12.2458 24.962 12.6834 25.3996C13.121 25.8372 13.7145 26.083 14.3333 26.083ZM21.3333 19.083V13.2497C21.3333 9.66801 19.42 6.66967 16.0833 5.87634V5.08301C16.0833 4.11467 15.3017 3.33301 14.3333 3.33301C13.365 3.33301 12.5833 4.11467 12.5833 5.08301V5.87634C9.235 6.66967 7.33333 9.65634 7.33333 13.2497V19.083L5 21.4163V22.583H23.6667V21.4163L21.3333 19.083Z" fill="#01B6E2" />
                </svg>
                <div className='app_uh_not_count' style={{left: 40 + "px"}}> <span>0</span></div>
            </div>
        </div>
    </div>
}
export default Chatheader;